(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.transition === 'marquee') {
        this.initMarquee();
        return;
      }
      this.slides = this.querySelectorAll('.announcement-bar__slide');
      if (this.slides.length <= 1) return;

      this.current = 0;
      this.transition = this.dataset.transition || 'fade';
      const interval = parseInt(this.dataset.interval) || 3000;
      this.timer = setInterval(() => this.next(), interval);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    initMarquee() {
      const track = this.querySelector('[data-ann-track]');
      const content = this.querySelector('[data-ann-content]');
      if (!track || !content) return;
      const pxPerSec = parseFloat(this.dataset.speed) || 23;
      const lead = parseFloat(this.dataset.lead) || 0;
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let lastWidth = 0;
      const fill = () => {
        const contentWidth = content.offsetWidth;
        if (!contentWidth) return;
        // A font swap or resize that leaves the width alone keeps the running scroll
        if (contentWidth === lastWidth) return;
        lastWidth = contentWidth;
        track.querySelectorAll('[data-ann-clone]').forEach(c => c.remove());
        const makeClone = () => {
          const clone = content.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-ann-clone', '');
          return clone;
        };
        // One copy ahead of the content so the tail of the last message shows
        // at the left edge on load, then enough copies after it to cover two
        // viewports (the loop is seamless because every copy is identical).
        track.insertBefore(makeClone(), content);
        const needed = Math.ceil((window.innerWidth * 2) / contentWidth) + 1;
        for (let i = 0; i < needed; i++) track.appendChild(makeClone());
        // Start with the first message `lead` px in from the left (so the end of
        // the previous message is visible), then scroll one copy per loop.
        // Duration is pixels per second so the pace matches the marquee section
        // whatever the message count is.
        const start = Math.round(lead - contentWidth);
        if (this._anim) this._anim.cancel();
        track.style.transform = 'translateX(' + start + 'px)';
        if (reduced || typeof track.animate !== 'function') return;
        this._anim = track.animate(
          [{ transform: 'translateX(' + start + 'px)' }, { transform: 'translateX(' + (start - contentWidth) + 'px)' }],
          { duration: (contentWidth / pxPerSec) * 1000, iterations: Infinity, easing: 'linear' }
        );
      };
      fill();
      this.classList.add('announcement-bar--ready');
      let resizeTimer;
      this._onResize = () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(fill, 150); };
      window.addEventListener('resize', this._onResize);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);
    }

    next() {
      const outgoing = this.slides[this.current];
      this.current = (this.current + 1) % this.slides.length;
      const incoming = this.slides[this.current];

      if (this.transition === 'slide') {
        outgoing.classList.add('announcement-bar__slide--exit');
        outgoing.classList.remove('announcement-bar__slide--active');
        incoming.classList.add('announcement-bar__slide--active');
        outgoing.addEventListener('transitionend', () => {
          outgoing.classList.remove('announcement-bar__slide--exit');
        }, { once: true });
      } else {
        outgoing.classList.remove('announcement-bar__slide--active');
        incoming.classList.add('announcement-bar__slide--active');
      }
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campus-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function contentWidth(track) {
      var kids = track.children;
      if (!kids.length) return 0;
      var last = kids[kids.length - 1];
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return last.offsetLeft + last.offsetWidth + gap - kids[0].offsetLeft;
    }

    function initRow(row, speed) {
      var track = row.querySelector('[data-wall-track]');
      if (!track || !track.children.length) return null;
      var originals = Array.prototype.slice.call(track.children);
      var w = contentWidth(track);
      if (!w) return null;
      var need = row.clientWidth * 2 + w;
      var copies = 0;
      while (track.scrollWidth < need && copies < 8) {
        originals.forEach(function (el) { track.appendChild(el.cloneNode(true)); });
        copies++;
      }
      if (reduce || !track.animate) return null;
      var dir = row.getAttribute('data-dir') === '-1' ? -1 : 1;
      var frames = dir < 0
        ? [{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-w) + 'px)' }]
        : [{ transform: 'translateX(' + (-w) + 'px)' }, { transform: 'translateX(0)' }];
      return track.animate(frames, { duration: (w / speed) * 1000, iterations: Infinity, easing: 'linear' });
    }

    function initWall(sec) {
      var speed = Math.max(2, parseFloat(sec.getAttribute('data-drift')) || 12);
      var anims = [];
      var rows = sec.querySelectorAll('[data-wall-row]');
      Array.prototype.forEach.call(rows, function (row, i) {
        // the back row drifts a touch slower so the layers separate
        var a = initRow(row, i === 0 ? speed * 0.72 : speed);
        if (a) anims.push(a);
      });

      var ticking = false;
      function update() {
        ticking = false;
        var r = sec.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var p = (vh - r.top) / (r.height + vh * 0.1);
        p = Math.max(0, Math.min(1, p));
        sec.style.setProperty('--p', p.toFixed(3));
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }

      var active = false;
      function setActive(on) {
        if (on === active) return;
        active = on;
        if (on) {
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          anims.forEach(function (a) { a.play(); });
          update();
        } else {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          anims.forEach(function (a) { a.pause(); });
        }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          setActive(entries[0].isIntersecting);
        }, { rootMargin: '200px 0px' }).observe(sec);
      } else {
        setActive(true);
      }

      // a finger on the wall holds it still
      sec.addEventListener('pointerdown', function () { anims.forEach(function (a) { a.pause(); }); });
      var resume = function () { if (active) anims.forEach(function (a) { a.play(); }); };
      sec.addEventListener('pointerup', resume);
      sec.addEventListener('pointercancel', resume);
      sec.addEventListener('pointerleave', resume);

      update();
    }

    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-campus-wall]'), function (sec) {
        if (sec.__wall) return;
        sec.__wall = true;
        initWall(sec);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionSort extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.collection__sort-trigger');
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.classList.toggle('collection__sort--open');
      });
      this._onDocClick = (e) => {
        if (!this.contains(e.target)) this.classList.remove('collection__sort--open');
      };
      document.addEventListener('click', this._onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
    }
  }
  if (!customElements.get('collection-sort')) {
    customElements.define('collection-sort', CollectionSort);
  }


  /* ----- Infinite scroll ----- */
  var _infiniteObserver = null;

  function initInfiniteScroll() {
    if (_infiniteObserver) {
      _infiniteObserver.disconnect();
      _infiniteObserver = null;
    }

    var sentinel = document.querySelector('[data-infinite-sentinel]');
    if (!sentinel) return;

    var grid = document.querySelector('[data-collection-grid]');
    var paginationNav = document.querySelector('[data-pagination-nav]');
    if (!grid) return;

    var nextUrl = sentinel.getAttribute('data-next-url');
    var currentPage = parseInt(sentinel.getAttribute('data-current-page'), 10);
    var totalPages = parseInt(sentinel.getAttribute('data-total-pages'), 10);
    var loading = false;

    /* On a deep-page landing (?page=N via old link or bookmark), keep the
       numbered pagination visible -- infinite scroll only loads forward, so
       it's the only route back to earlier products. */
    if (paginationNav) {
      if (currentPage <= 1) paginationNav.setAttribute('data-pagination-hidden', '');
      else paginationNav.removeAttribute('data-pagination-hidden');
    }

    if (!nextUrl || currentPage >= totalPages) {
      sentinel.hidden = true;
      return;
    }

    sentinel.hidden = false;

    _infiniteObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading && nextUrl) {
        loadNextPage();
      }
    }, { rootMargin: '200px' });

    _infiniteObserver.observe(sentinel);

    function loadNextPage() {
      loading = true;

      fetch(nextUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to fetch');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var fetchedGrid = doc.querySelector('[data-collection-grid]');
          if (fetchedGrid) {
            while (fetchedGrid.firstChild) {
              grid.appendChild(fetchedGrid.firstChild);
            }
          }

          var fetchedSentinel = doc.querySelector('[data-infinite-sentinel]');
          if (fetchedSentinel) {
            nextUrl = fetchedSentinel.getAttribute('data-next-url');
            currentPage = parseInt(fetchedSentinel.getAttribute('data-current-page'), 10);
          } else {
            nextUrl = null;
          }

          if (!nextUrl || currentPage >= totalPages) {
            sentinel.hidden = true;
            _infiniteObserver.disconnect();
          }

          loading = false;
        })
        .catch(function () {
          sentinel.hidden = true;
          _infiniteObserver.disconnect();
          if (paginationNav) paginationNav.removeAttribute('data-pagination-hidden');
          loading = false;
        });
    }
  }

  initInfiniteScroll();

  /* ----- Collection filters AJAX web component ----- */
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this._abortController = null;
      this._priceDebounce = null;

      this._onPopState = this._handlePopState.bind(this);
      window.addEventListener('popstate', this._onPopState);

      this._onKeyDown = function (e) {
        if (e.key === 'Escape') this.closeDrawer();
      }.bind(this);
      document.addEventListener('keydown', this._onKeyDown);

      this.addEventListener('click', this._handleClick.bind(this));

      var form = this.querySelector('[data-collection-filters-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          this._submitForm(form);
        }.bind(this));

        form.addEventListener('change', function (e) {
          if (e.target.type === 'checkbox') this._submitForm(form);
        }.bind(this));

        form.addEventListener('input', function (e) {
          if (e.target.closest('.filter-price')) {
            clearTimeout(this._priceDebounce);
            this._priceDebounce = setTimeout(function () {
              this._submitForm(form);
            }.bind(this), 600);
          }
        }.bind(this));
      }

      var toggle = this.querySelector('[data-filter-toggle]');
      if (toggle) toggle.addEventListener('click', this.openDrawer.bind(this));
      var closeBtn = this.querySelector('[data-filter-close]');
      if (closeBtn) closeBtn.addEventListener('click', this.closeDrawer.bind(this));
      var backdrop = this.querySelector('[data-filter-backdrop]');
      if (backdrop) backdrop.addEventListener('click', this.closeDrawer.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._onPopState);
      document.removeEventListener('keydown', this._onKeyDown);
      if (this._abortController) this._abortController.abort();
      clearTimeout(this._priceDebounce);
    }

    openDrawer() {
      var sidebar = this.querySelector('[data-filter-sidebar]');
      var backdrop = this.querySelector('[data-filter-backdrop]');
      if (sidebar) sidebar.classList.add('collection__sidebar--open');
      if (backdrop) backdrop.classList.add('collection__drawer-backdrop--visible');
      document.body.style.overflow = 'hidden';
    }

    closeDrawer() {
      var sidebar = this.querySelector('[data-filter-sidebar]');
      var backdrop = this.querySelector('[data-filter-backdrop]');
      if (sidebar) sidebar.classList.remove('collection__sidebar--open');
      if (backdrop) backdrop.classList.remove('collection__drawer-backdrop--visible');
      document.body.style.overflow = '';
    }

    _handleClick(e) {
      var chip = e.target.closest('.collection__chip');
      if (chip) {
        e.preventDefault();
        this.navigateTo(chip.href);
        return;
      }

      var clearAll = e.target.closest('.collection__clear-all');
      if (clearAll) {
        e.preventDefault();
        this.navigateTo(clearAll.href);
        return;
      }
    }

    _handlePopState() {
      this.navigateTo(window.location.href, false);
    }

    _submitForm(form) {
      var formData = new FormData(form);
      var url = new URL(form.action, window.location.origin);

      url.search = '';

      for (var pair of formData.entries()) {
        if (pair[1] !== '') url.searchParams.append(pair[0], pair[1]);
      }

      var currentUrl = new URL(window.location.href);
      var sortBy = currentUrl.searchParams.get('sort_by');
      if (sortBy) url.searchParams.set('sort_by', sortBy);

      this.closeDrawer();
      this.navigateTo(url.toString());
    }

    navigateTo(url, pushState) {
      if (pushState === undefined) pushState = true;
      if (this._abortController) this._abortController.abort();
      this._abortController = new AbortController();

      var sectionId = this.getAttribute('data-section-id');
      var grid = this.querySelector('[data-collection-grid]');
      if (!grid) return;

      grid.classList.add('collection__grid--loading');

      var fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      var self = this;

      fetch(fetchUrl.toString(), { signal: this._abortController.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to fetch');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* Replace product grid */
          var newGrid = doc.querySelector('[data-collection-grid]');
          if (newGrid) grid.innerHTML = newGrid.innerHTML;
          else grid.innerHTML = '';

          /* Replace product count */
          var newCount = doc.querySelector('[data-product-count]');
          var oldCount = self.querySelector('[data-product-count]');
          if (newCount && oldCount) oldCount.textContent = newCount.textContent;

          /* Replace active chips bar */
          var newChips = doc.querySelector('[data-active-filters]');
          var oldChips = self.querySelector('[data-active-filters]');
          if (newChips && oldChips) {
            oldChips.replaceWith(newChips);
          } else if (!newChips && oldChips) {
            oldChips.remove();
          } else if (newChips && !oldChips) {
            var body = self.querySelector('.collection__body');
            if (body) body.before(newChips);
          }

          /* Replace filter badge */
          var newBadge = doc.querySelector('[data-filter-badge]');
          var oldBadge = self.querySelector('[data-filter-badge]');
          var toggleBtn = self.querySelector('[data-filter-toggle]');
          if (newBadge && !oldBadge && toggleBtn) {
            toggleBtn.insertAdjacentHTML('beforeend', newBadge.outerHTML);
          } else if (!newBadge && oldBadge) {
            oldBadge.remove();
          }

          /* Replace sidebar body (filter counts & active states) */
          var newSidebarBody = doc.querySelector('.collection__sidebar-body');
          var oldSidebarBody = self.querySelector('.collection__sidebar-body');
          if (newSidebarBody && oldSidebarBody) {
            oldSidebarBody.innerHTML = newSidebarBody.innerHTML;
          }

          /* Replace sentinel */
          var newSentinel = doc.querySelector('[data-infinite-sentinel]');
          var oldSentinel = self.querySelector('[data-infinite-sentinel]');
          if (newSentinel && oldSentinel) oldSentinel.replaceWith(newSentinel);

          /* Replace pagination */
          var newPag = doc.querySelector('[data-pagination-nav]');
          var oldPag = self.querySelector('[data-pagination-nav]');
          if (newPag && oldPag) oldPag.replaceWith(newPag);
          else if (oldPag && !newPag) oldPag.remove();

          /* Replace category pills active state */
          var newPills = doc.querySelector('.collection__filters-scroll');
          var oldPills = self.querySelector('.collection__filters-scroll');
          if (newPills && oldPills) oldPills.innerHTML = newPills.innerHTML;

          initInfiniteScroll();
          grid.classList.remove('collection__grid--loading');

          if (pushState) {
            var pushUrl = new URL(url, window.location.origin);
            pushUrl.searchParams.delete('section_id');
            history.pushState(null, '', pushUrl.toString());
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          grid.classList.remove('collection__grid--loading');
        });
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }

  /* ----- Category pill filter (delegates AJAX to CollectionFilters) ----- */
  class CollectionFilter extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this._onClick.bind(this));
    }

    _onClick(e) {
      var link = e.target.closest('.collection__filter-btn');
      if (!link) return;
      e.preventDefault();

      this.querySelectorAll('.collection__filter-btn').forEach(function (btn) {
        btn.classList.remove('collection__filter-btn--active');
      });
      link.classList.add('collection__filter-btn--active');

      var parent = this.closest('collection-filters');
      if (parent) {
        var targetUrl = new URL(link.href, window.location.origin);
        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.forEach(function (val, key) {
          if (key.startsWith('filter.')) targetUrl.searchParams.append(key, val);
        });
        parent.navigateTo(targetUrl.toString());
      }
    }
  }

  if (!customElements.get('collection-filter')) {
    customElements.define('collection-filter', CollectionFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saturday-story')) {
    customElements.define('saturday-story', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.mediaObserver?.disconnect();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.photos = [...this.querySelectorAll('[data-story-photo]')];
        this.chapters = [...this.querySelectorAll('[data-story-chapter]')];
        this.selectors = [...this.querySelectorAll('[data-story-select]')];
        this.index = 0;
        this.show(0);
        this.classList.add('is-enhanced');
        this.querySelectorAll('[data-story-controls]').forEach(control => { control.hidden = false; });
        this.addEventListener('click', event => {
          const step = event.target.closest('[data-story-step]');
          const select = event.target.closest('[data-story-select]');
          if (step) this.show(this.index + Number(step.dataset.storyStep));
          if (select) this.show(Number(select.dataset.storySelect));
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (!event.target.closest('button')) return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          if (event.target.matches('[data-story-select]')) this.selectors[this.index].focus();
        }, options);
        const gallery = this.querySelector('[data-story-gallery]');
        const loadMedia = () => {
          this.querySelectorAll('template[data-story-image]').forEach(template => {
            template.replaceWith(template.content.cloneNode(true));
          });
          this.classList.add('is-ready');
          this.mediaObserver?.disconnect();
        };
        if ('IntersectionObserver' in window) {
          this.mediaObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) loadMedia();
          }, { rootMargin: '600px 0px' });
          this.mediaObserver.observe(gallery);
        } else {
          loadMedia();
        }
        gallery.addEventListener('pointerdown', event => {
          if (event.target.closest('button') || !event.isPrimary) return;
          this.pointer = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, options);
        gallery.addEventListener('pointerup', event => {
          if (!this.pointer || this.pointer.id !== event.pointerId) return;
          const x = event.clientX - this.pointer.x;
          const y = event.clientY - this.pointer.y;
          this.pointer = null;
          if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.index + (x < 0 ? 1 : -1));
        }, options);
        gallery.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.chapters.findIndex(chapter => chapter.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, options);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.mediaObserver?.disconnect();
      }
      show(index) {
        const total = this.chapters.length;
        if (!total) return;
        this.index = ((index % total) + total) % total;
        this.photos.forEach((photo, i) => {
          let position = 'hidden';
          if (i === this.index) position = 'active';
          else if (i === (this.index + 1) % total) position = 'next';
          else if (i === (this.index - 1 + total) % total) position = 'previous';
          photo.dataset.position = position;
          photo.setAttribute('aria-hidden', String(i !== this.index));
        });
        this.chapters.forEach((chapter, i) => {
          chapter.setAttribute('aria-hidden', String(i !== this.index));
          chapter.inert = i !== this.index;
        });
        this.selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class PasswordSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.emailInput = this.querySelector('input[type="email"]');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.status = this.querySelector('[data-signup-status]');

      if (!this.form || !this.emailInput || !this.submitButton || !this.status) return;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();

      if (!this.emailInput.reportValidity()) return;

      var companyId = this.dataset.companyId;
      var listId = this.dataset.listId;
      if (!companyId || !listId) return;

      var email = this.emailInput.value.trim();
      if (!email) return;

      var button = this.submitButton;
      var originalLabel = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (this.dataset.loadingText) button.textContent = this.dataset.loadingText;

      this.status.textContent = '';
      this.status.classList.remove('password-hero__status--error', 'password-hero__status--success');

      var profileAttributes = { email: email };
      var params = new URLSearchParams(window.location.search);
      var utmProperties = {};
      var hasUtm = false;
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) {
        var value = params.get(key);
        if (value) {
          utmProperties[key] = value;
          hasUtm = true;
        }
      });
      if (hasUtm) profileAttributes.properties = utmProperties;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Password Page Waitlist',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId }
            }
          }
        }
      };

      var self = this;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo subscribe failed: ' + response.status);
          self.form.hidden = true;
          self.status.classList.add('password-hero__status--success');
          self.status.textContent = self.dataset.successMessage || '';
        })
        .catch(function () {
          self.status.classList.add('password-hero__status--error');
          self.status.textContent = self.dataset.errorMessage || '';
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
        });
    }
  }

  if (!customElements.get('password-signup')) {
    customElements.define('password-signup', PasswordSignup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  // "[size guide]" link: open the Size guide accordion in the product section
  // and scroll to it, like the link beside the Size label does.
  document.querySelectorAll('[data-faq-size-guide]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var details = document.querySelector('[data-size-guide]');
      if (!details) return;
      event.preventDefault();
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transparent-pricing"] && !Shopify.designMode) return;
  try {
    
  /* Mirror the buy box: price, struck compare-at and the sale chip, kept in
     sync when the shopper changes a variant. The product section owns the
     numbers; this block only copies them. */
  (function () {
    var root = document.querySelector('[data-transparent-pricing]');
    var priceEl = document.querySelector('product-page [data-current-price]');
    if (!root || !priceEl) return;
    var compareEl = document.querySelector('product-page [data-compare-price]');
    var chipEl = document.querySelector('product-page [data-sale-badge]');
    var tpPrice = root.querySelector('[data-tp-price]');
    var tpCompare = root.querySelector('[data-tp-compare]');
    var tpChip = root.querySelector('[data-tp-chip]');
    var tpHeading = root.querySelector('[data-tp-heading]');
    var template = tpHeading ? tpHeading.getAttribute('data-template') : '';

    function shortMoney(text) {
      return (text || '').trim().replace(/\.00(?!\d)/, '');
    }

    function sync() {
      var price = shortMoney(priceEl.textContent);
      if (!price) return;
      if (tpPrice) tpPrice.textContent = price;
      if (tpHeading && template) tpHeading.textContent = template.replace('[price]', price);
      var onSale = compareEl && !compareEl.classList.contains('hidden');
      if (tpCompare) {
        tpCompare.textContent = onSale ? shortMoney(compareEl.textContent) : '';
        tpCompare.classList.toggle('hidden', !onSale);
      }
      if (tpChip) {
        var chip = chipEl ? chipEl.querySelector('.product__deal-chip') : null;
        if (onSale && chip) {
          tpChip.innerHTML = '';
          tpChip.appendChild(chip.cloneNode(true));
          tpChip.classList.remove('hidden');
        } else {
          tpChip.classList.add('hidden');
        }
      }
    }

    sync();
    var row = priceEl.closest('.product__price') || priceEl.parentNode;
    new MutationObserver(function () { setTimeout(sync, 0); })
      .observe(row, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  })();

  } catch(e) { console.error(e); }
})();
})();
